import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { App } from './App'
import './styles.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      // 같은 query key 의 다음 fetch 동안 이전 데이터 유지 — select/sidebar/list 가
      // 페이지 전환 시 잠깐 빈 값으로 깜빡이지 않음.
      placeholderData: (prev: unknown) => prev,
    },
  },
})

const root = document.getElementById('root')
if (!root) throw new Error('#root missing in index.html')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
